import { useState } from "react";
import "./LocationFlip.css";

export default function LocationFlipCard({ front, back }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="location-flip-wrap">
      <div className={`location-flip-inner ${flipped ? "is-flipped" : ""}`}>
        {/* backface-visibility is what's supposed to hide whichever face isn't
            facing the camera, but Safari doesn't reliably honour it on an
            absolutely positioned 3D face — the hidden one can still paint
            (mirrored) and, worse, still receive clicks. pointer-events and
            aria-hidden are driven straight from the flip state instead, so
            the inactive face can't be interacted with regardless of what any
            browser's 3D rendering does. */}
        <div
          className="location-flip-face front"
          aria-hidden={flipped}
          style={{ pointerEvents: flipped ? "none" : "auto" }}
        >
          {front({ flipped, setFlipped })}
        </div>

        <div
          className="location-flip-face back"
          aria-hidden={!flipped}
          style={{ pointerEvents: flipped ? "auto" : "none" }}
        >
          {back({ flipped, setFlipped })}
        </div>
      </div>
    </div>
  );
}
